import React from "react";
import * as Styles from "./UscCarDeliverySelectTransportation.styles";
import Preloader from "../../../../../shared-components/deprecated-styled-components/toyota/custom/Preloader";
import { CarDeliveryTransportationOption } from "../../../../utils/carDeliveryUtils";
import { setCarDeliveryTransportation } from "../../../../redux/actions/UscCarDeliveryActions";
import { formatPriceIntl } from "../../../../../../common-deprecated/priceUtils";
import { UscLabel } from "../../../../utils/labels";
import { type UscDispatchType, useUscSelector } from "../../../../redux/store";
import Text from "../../../../../shared-components/toyota/styles/atoms/Text";
import Radio from "../../../../../shared-components/toyota/styles/atoms/Radio";
import Icon from "../../../../../shared-components/toyota/styles/atoms/Icon";
import { trackCarDeliverySelectTransportationType } from "../../../../utils/tracking";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

const UscCarDeliverySelectTransportation = (): JSX.Element | null => {
    const dispatch = useDispatch<UscDispatchType>();
    const tempCarDeliveryConfig = useUscSelector((state) => state.carDelivery.tempDeliveryConfig);
    const uscEnv = useUscSelector((state) => state.vehicle.type);
    const transportationType = useUscSelector((state) => state.carDelivery.deliveryTransportation);
    const commonSettings = useUscSelector((state) => state.commonSettings);

    if (!tempCarDeliveryConfig || !tempCarDeliveryConfig?.prices) return <Preloader />;

    const { prices } = tempCarDeliveryConfig;

    return (
        <>
            <Styles.Header>
                <Text variant="h5-regular" tag="h3">
                    <UscLabel label="uscCarDeliverySelectTransportationTitle" />
                </Text>
                <Text tag="p">
                    <UscLabel label="uscCarDeliverySelectTransportationDescription" />
                </Text>
            </Styles.Header>
            <Styles.CardsWrapper>
                <Styles.TransportationTypeCard
                    onClick={() => {
                        trackCarDeliverySelectTransportationType(uscEnv, CarDeliveryTransportationOption.Truck);
                        dispatch(setCarDeliveryTransportation(CarDeliveryTransportationOption.Truck));
                    }}
                    isActive={transportationType === CarDeliveryTransportationOption.Truck}
                >
                    <Styles.TransportationTypeCardHeader>
                        <Icon variant="truck" iconSize="medium" />
                        <Radio
                            variant="basic"
                            id="transportationTypeTruck"
                            position="right"
                            onClick={() => {
                                trackCarDeliverySelectTransportationType(uscEnv, CarDeliveryTransportationOption.Truck);
                                dispatch(setCarDeliveryTransportation(CarDeliveryTransportationOption.Truck));
                            }}
                            checked={transportationType === CarDeliveryTransportationOption.Truck}
                        >
                            <Styles.InputLabel shown={transportationType === CarDeliveryTransportationOption.Truck}>
                                <UscLabel label="uscCarDeliverySelectTransportationOptionSelected" />
                            </Styles.InputLabel>
                        </Radio>
                    </Styles.TransportationTypeCardHeader>
                    <Text variant="body-regular" tag="h4" spacing={{ mb: "spacing-1" }}>
                        <UscLabel label="uscCarDeliverySelectTransportationOptionTruckTitle" />
                    </Text>
                    <Text variant="body-small-book">
                        <UscLabel label="uscCarDeliverySelectTransportationOptionTruckDescription" />
                    </Text>
                    {prices.truck.cashPriceInclVat && (
                        <Styles.PriceWrapper>
                            <Text variant="body-semibold">
                                {formatPriceIntl(commonSettings, prices.truck.cashPriceInclVat).primaryPrice}
                            </Text>
                        </Styles.PriceWrapper>
                    )}
                </Styles.TransportationTypeCard>
                <Styles.TransportationTypeCard
                    isActive={transportationType === CarDeliveryTransportationOption.ProfessionalDriver}
                    onClick={() => {
                        trackCarDeliverySelectTransportationType(
                            uscEnv,
                            CarDeliveryTransportationOption.ProfessionalDriver,
                        );
                        dispatch(setCarDeliveryTransportation(CarDeliveryTransportationOption.ProfessionalDriver));
                    }}
                >
                    <Styles.TransportationTypeCardHeader>
                        <Icon variant="steering-wheel" iconSize="medium" />
                        <Radio
                            id="transportationTypeDriver"
                            variant="basic"
                            position="right"
                            onClick={() => {
                                trackCarDeliverySelectTransportationType(
                                    uscEnv,
                                    CarDeliveryTransportationOption.ProfessionalDriver,
                                );
                                dispatch(
                                    setCarDeliveryTransportation(CarDeliveryTransportationOption.ProfessionalDriver),
                                );
                            }}
                            checked={transportationType === CarDeliveryTransportationOption.ProfessionalDriver}
                        >
                            <Styles.InputLabel
                                shown={transportationType === CarDeliveryTransportationOption.ProfessionalDriver}
                            >
                                <UscLabel label="uscCarDeliverySelectTransportationOptionSelected" />
                            </Styles.InputLabel>
                        </Radio>
                    </Styles.TransportationTypeCardHeader>
                    <Text variant="body-regular" tag="h4" spacing={{ mb: "spacing-1" }}>
                        <UscLabel label="uscCarDeliverySelectTransportationOptionProfessionalTitle" />
                    </Text>
                    <Text variant="body-small-book">
                        <UscLabel label="uscCarDeliverySelectTransportationOptionProfessionalDescription" />
                    </Text>
                    {prices.professionalDriver.cashPriceInclVat && (
                        <Styles.PriceWrapper>
                            <Text variant="body-semibold">
                                {
                                    formatPriceIntl(commonSettings, prices.professionalDriver.cashPriceInclVat)
                                        .primaryPrice
                                }
                            </Text>
                        </Styles.PriceWrapper>
                    )}
                </Styles.TransportationTypeCard>
            </Styles.CardsWrapper>
        </>
    );
};

export default UscCarDeliverySelectTransportation;
